"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _IconCount = _interopRequireDefault(require("../IconCount/IconCount"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ThumbsUpIcon = function ThumbsUpIcon(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
  }));
};

ThumbsUpIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
};

var ButtonLike = function ButtonLike(_ref) {
  var count = _ref.count,
      active = _ref.active,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      showZeroValue = _ref.showZeroValue,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      props = _objectWithoutPropertiesLoose(_ref, ["count", "active", "disabled", "onClick", "showZeroValue", "icon", "iconSize"]);

  var ariaLabelCount = count + " " + (count === 1 ? 'like' : 'likes') + ".";
  var ariaLabel = active ? 'Liked' : 'Like';
  return (0, _themeUi.jsx)("button", _extends({}, props, {
    type: "button",
    disabled: disabled,
    onClick: onClick,
    sx: {
      cursor: disabled ? 'default' : 'pointer',
      pointerEvents: disabled ? 'none' : 'auto'
    },
    "aria-label": ariaLabelCount + " " + ariaLabel + " "
  }), (0, _themeUi.jsx)(_IconCount["default"], {
    "aria-hidden": true,
    icon: icon,
    iconSize: iconSize,
    count: showZeroValue ? count : count > 0 && count,
    sx: _extends({
      opacity: disabled ? 0.5 : 1,
      color: 'textMediumEmphasis'
    }, active && {
      '& svg': {
        color: 'alerts.information'
      }
    })
  }));
};

ButtonLike.propTypes = {
  icon: _propTypes["default"].func,
  count: _propTypes["default"].number,
  active: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  showZeroValue: _propTypes["default"].bool,
  iconSize: _propTypes["default"].number
};
ButtonLike.defaultProps = {
  icon: ThumbsUpIcon,
  iconSize: 1,
  count: 0,
  active: false,
  disabled: false,
  showZeroValue: false
};
var _default = ButtonLike;
exports["default"] = _default;